/* ============================================================================
   Cena do login: um parque de dispositivos gerenciado por um ponto central.

   SUBSTITUI O FOGUETE (10/09/2026, a pedido: "tirar o foguete e colocar
   dispositivos, mais moderno, com animacoes").

   POR QUE ESTE DESENHO, e nao um aparelho bonito no meio: o sistema e um MDM, e o
   que ele faz e mandar politica para MUITOS aparelhos e receber o estado deles de
   volta. Um aparelho sozinho ilustra "celular"; o que ilustra o produto e a
   RELACAO - o centro, os aparelhos ligados a ele e o trafego nos dois sentidos.
   Por isso a cena tem hub, linhas e pacotes viajando nelas.

   OS NOMES DOS PRODUTOS FICARAM. Estavam nas escotilhas do foguete (GPSvc, GPSt,
   GPSi, GPSamigo, GPSmil, GPSvista) e sao informacao, nao enfeite: dizem que o hub
   atende varios produtos da casa. Aqui cada um vira um aparelho do parque.

   SVG INLINE, e nao arquivo: o desenho reage ao tema (usa as cores por props e
   `currentColor`), anima sem biblioteca e nao adiciona uma requisicao. O foguete
   era um .svg de 114 KB baixado a parte.

   MOVIMENTO - tres camadas, todas lentas de proposito. Tela de login e lugar de
   digitar senha; animacao rapida ali disputa atencao com o campo:
     1. os aparelhos respiram (sobe/desce ~4px, cada um em tempo diferente);
     2. pulsos percorrem as linhas do centro para as pontas - e o "aplicando
        politica" desenhado;
     3. os aneis do centro expandem e somem, como alcance.

   `prefers-reduced-motion` ja e respeitado globalmente pelo guarda do global.css,
   que zera a duracao de toda animacao. Nao ha regra propria aqui - duplicar a
   regra seria mais um lugar para esquecer de atualizar.
   ============================================================================ */

const APARELHOS = [
  // x/y sao o CENTRO de cada aparelho, num viewBox de 520x520 com o hub em 260,260.
  { nome: 'GPSvc', x: 260, y: 96, atraso: '0s' },
  { nome: 'GPSt', x: 108, y: 186, atraso: '0.6s' },
  { nome: 'GPSi', x: 412, y: 186, atraso: '1.2s' },
  { nome: 'GPSamigo', x: 108, y: 350, atraso: '1.8s' },
  { nome: 'GPSvista', x: 412, y: 350, atraso: '2.4s' },
  { nome: 'GPSmil', x: 260, y: 440, atraso: '3s' },
];

const HUB = { x: 260, y: 260 };

/* ICONES DOS APLICATIVOS QUE MAIS APARECEM NO PARQUE.

   A lista nao foi inventada: veio de uma consulta ao consumo dos ultimos 30 dias
   (TAB_DISPOSITIVO_APLICATIVO_CONSUMO_DIA). Os primeiros colocados sao, nesta
   ordem, loja de aplicativos, navegador, mensagens, video, trabalho e os apps da
   propria casa. Sao esses que o desenho mostra.

   SAO GLIFOS DE CATEGORIA, e nao logotipos. Dois motivos: em 9px um logo real nao
   e legivel - vira uma mancha colorida -, e reproduzir marca de terceiro numa tela
   de produto e risco que nao se corre por enfeite. Um balao diz "mensagens" tao
   bem quanto o logo, e nao pertence a ninguem. */
const APPS = [
  // loja - o triangulo de "play"
  { cor: '#34d399', d: 'M3.2 2.2 L7.6 5 L3.2 7.8 Z' },
  // navegador - globo
  { cor: '#60a5fa', d: 'M5 1.4 A3.6 3.6 0 1 1 4.99 1.4 M1.4 5 H8.6 M5 1.4 C3.2 3 3.2 7 5 8.6 C6.8 7 6.8 3 5 1.4' },
  // mensagens - balao
  { cor: '#4ade80', d: 'M1.6 2.2 H8.4 V6.4 H4.4 L2.6 8.2 V6.4 H1.6 Z' },
  // video - play em bloco
  { cor: '#f87171', d: 'M1.4 2.6 H8.6 V7.4 H1.4 Z M4.1 4 L6.4 5 L4.1 6 Z' },
  // trabalho / reuniao - duas pessoas
  { cor: '#a78bfa', d: 'M3.4 4.2 A1.2 1.2 0 1 1 3.39 4.2 M6.6 4.2 A1.2 1.2 0 1 1 6.59 4.2 M1.5 8 C1.5 6.4 3 6 3.4 6 C3.8 6 5.3 6.4 5.3 8 Z M4.9 8 C5 6.8 6.2 6 6.6 6 C7 6 8.5 6.4 8.5 8 Z' },
  // localizacao - o pino, que e o assunto da casa
  { cor: '#fbbf24', d: 'M5 1.5 C6.7 1.5 8 2.8 8 4.4 C8 6.2 5 8.6 5 8.6 C5 8.6 2 6.2 2 4.4 C2 2.8 3.3 1.5 5 1.5 Z' },
];

/* PARTICULAS FLUTUANDO.

   Lista FIXA, e nao `Math.random()` no render: com valores sorteados a cada
   render as particulas saltariam de lugar a cada re-renderizacao do componente -
   e o formulario ao lado re-renderiza a cada tecla digitada no e-mail.

   `dx/dy` sao o deslocamento total de cada uma; `d` a duracao e `atraso` o
   comeco. Duracoes diferentes e primas entre si evitam que elas caiam em
   sincronia e formem um "pulso" visivel. */
const PARTICULAS = [
  { x: 60, y: 470, r: 1.8, dx: 26, dy: -300, d: 17, atraso: 0 },
  { x: 140, y: 505, r: 1.2, dx: -18, dy: -260, d: 21, atraso: 2.5 },
  { x: 210, y: 490, r: 2.2, dx: 34, dy: -340, d: 15, atraso: 5 },
  { x: 300, y: 512, r: 1.4, dx: -26, dy: -290, d: 23, atraso: 1.2 },
  { x: 370, y: 498, r: 1.9, dx: 20, dy: -320, d: 19, atraso: 7 },
  { x: 448, y: 486, r: 1.1, dx: -30, dy: -250, d: 25, atraso: 3.4 },
  { x: 95, y: 300, r: 1.5, dx: 40, dy: -210, d: 22, atraso: 9 },
  { x: 430, y: 320, r: 1.7, dx: -38, dy: -230, d: 18, atraso: 4.2 },
  { x: 255, y: 455, r: 1.3, dx: 12, dy: -270, d: 26, atraso: 11 },
  { x: 175, y: 420, r: 2.0, dx: -22, dy: -300, d: 16, atraso: 6.3 },
  { x: 345, y: 440, r: 1.2, dx: 28, dy: -280, d: 24, atraso: 8.1 },
  { x: 500, y: 400, r: 1.6, dx: -34, dy: -240, d: 20, atraso: 12 },
];

export default function CenaDispositivos({ className = '' }) {
  return (
    <svg
      viewBox="0 0 520 520"
      className={className}
      role="img"
      aria-label="Parque de dispositivos gerenciado pelo GPShub: seis aparelhos conectados a um ponto central"
      style={{ width: '100%', maxWidth: 560, height: 'auto', display: 'block' }}
    >
      <defs>
        <linearGradient id="cd-tela" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor="#8fd4ff" stopOpacity="0.95" />
          <stop offset="100%" stopColor="#2f7fd4" stopOpacity="0.85" />
        </linearGradient>

        <linearGradient id="cd-hub" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#bfe6ff" />
          <stop offset="100%" stopColor="#5aa6ee" />
        </linearGradient>

        <radialGradient id="cd-brilho" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#9fdcff" stopOpacity="0.34" />
          <stop offset="60%" stopColor="#4f9fe6" stopOpacity="0.12" />
          <stop offset="100%" stopColor="#0b1b33" stopOpacity="0" />
        </radialGradient>
      </defs>

      <style>{`
        /* Nomes com prefixo cd- para nao colidir com nada da pagina. */
        @keyframes cd-respirar { 0%,100% { transform: translateY(0); } 50% { transform: translateY(-4px); } }
        @keyframes cd-anel     { 0% { r: 46; opacity: .55; } 100% { r: 150; opacity: 0; } }
        @keyframes cd-pulso    { 0% { offset-distance: 0%; opacity: 0; }
                                 12% { opacity: 1; }
                                 88% { opacity: 1; }
                                 100% { offset-distance: 100%; opacity: 0; } }
        @keyframes cd-piscar   { 0%,100% { opacity: .35; } 50% { opacity: 1; } }

        .cd-aparelho { animation: cd-respirar 6s ease-in-out infinite; }
        .cd-anel     { animation: cd-anel 4s ease-out infinite; }
        .cd-pulso    { animation: cd-pulso 3.2s linear infinite; }
        .cd-led      { animation: cd-piscar 2.4s ease-in-out infinite; }

        /* Sobem, derivam de lado e apagam. A variavel dentro do transform deixa um
           keyframe unico servir as doze, cada uma com o seu deslocamento.
           (Sem crase neste comentario: ele vive dentro de um template literal, e
            uma crase aqui fecharia a string - foi o que quebrou na primeira vez.) */
        @keyframes cd-voar {
          0%   { transform: translate(0, 0);                 opacity: 0; }
          12%  {                                              opacity: .85; }
          80%  {                                              opacity: .5; }
          100% { transform: translate(var(--dx), var(--dy)); opacity: 0; }
        }
        .cd-particula { animation: cd-voar linear infinite; }
      `}</style>

      <circle cx={HUB.x} cy={HUB.y} r="250" fill="url(#cd-brilho)" />

      {/* Particulas ATRAS dos aparelhos: passando por cima elas roubariam a
          leitura da tela de cada um, que e o que importa na cena. */}
      {PARTICULAS.map((p, i) => (
        <circle
          key={`f-${i}`}
          className="cd-particula"
          cx={p.x}
          cy={p.y}
          r={p.r}
          fill="#cfeaff"
          style={{
            '--dx': `${p.dx}px`,
            '--dy': `${p.dy}px`,
            animationDuration: `${p.d}s`,
            animationDelay: `${p.atraso}s`,
          }}
        />
      ))}

      {/* LINHAS ATE CADA APARELHO. Ficam atras de tudo e bem apagadas: elas
          existem para dizer "estao ligados", nao para serem lidas. */}
      <g stroke="#7cc4f5" strokeOpacity="0.28" strokeWidth="1.5" strokeLinecap="round">
        {APARELHOS.map((a) => (
          <line key={a.nome} x1={HUB.x} y1={HUB.y} x2={a.x} y2={a.y} />
        ))}
      </g>

      {/* ANEIS DE ALCANCE saindo do hub. Tres, defasados, para o movimento ser
          continuo em vez de piscar de uma vez. */}
      <g fill="none" stroke="#8fd4ff" strokeWidth="1.2">
        <circle className="cd-anel" cx={HUB.x} cy={HUB.y} r="46" />
        <circle className="cd-anel" cx={HUB.x} cy={HUB.y} r="46" style={{ animationDelay: '1.33s' }} />
        <circle className="cd-anel" cx={HUB.x} cy={HUB.y} r="46" style={{ animationDelay: '2.66s' }} />
      </g>

      {/* PACOTES VIAJANDO do centro para cada aparelho - a politica sendo
          aplicada. `offsetPath` segue a mesma reta da linha, entao os dois nunca
          saem de sincronia. */}
      {APARELHOS.map((a, i) => (
        <circle
          key={`p-${a.nome}`}
          className="cd-pulso"
          r="3.2"
          fill="#cbeaff"
          style={{
            offsetPath: `path("M ${HUB.x} ${HUB.y} L ${a.x} ${a.y}")`,
            animationDelay: `${i * 0.5}s`,
          }}
        />
      ))}

      {APARELHOS.map((a) => (
        <g key={a.nome} className="cd-aparelho" style={{ animationDelay: a.atraso }}>
          {/* Aparelho: 54x86, cantos redondos, tela com margem - a silhueta de
              celular e reconhecida sem precisar de detalhe. */}
          <rect
            x={a.x - 27}
            y={a.y - 43}
            width="54"
            height="86"
            rx="11"
            fill="#102a4c"
            stroke="#63a9e0"
            strokeOpacity="0.55"
            strokeWidth="1.4"
          />
          <rect x={a.x - 21} y={a.y - 35} width="42" height="60" rx="5" fill="url(#cd-tela)" opacity="0.9" />

          {/* Led de estado: verde piscando devagar = aparelho reportando. */}
          <circle className="cd-led" cx={a.x} cy={a.y + 33} r="2.6" fill="#4ade80" />

          {/* NOME NO TOPO DA TELA, e nao no meio: o meio agora e dos icones.

              `textLength` + `lengthAdjust` comprimem ate caber nos 38px uteis -
              sem isso "GPSamigo" e "GPSvista" ultrapassavam a moldura do aparelho.
              Comprimir e melhor que diminuir a fonte de todos: os nomes curtos
              ficam no tamanho cheio. */}
          <text
            x={a.x}
            y={a.y - 26}
            textAnchor="middle"
            fontSize="7.5"
            fontWeight="800"
            fill="#0b1b33"
            fillOpacity="0.78"
            textLength={a.nome.length > 6 ? 34 : undefined}
            lengthAdjust="spacingAndGlyphs"
            style={{ letterSpacing: '0.02em' }}
          >
            {a.nome}
          </text>

          {/* GRADE DE APLICATIVOS: 3 x 2, os seis que mais aparecem no parque.
              Cada tile e um quadrado arredondado com o glifo da categoria por
              cima - a mesma leitura de uma tela inicial de Android. */}
          {APPS.map((app, i) => {
            const col = i % 3;
            const lin = Math.floor(i / 3);
            const ix = a.x - 16.5 + col * 11.5;
            const iy = a.y - 18 + lin * 13;
            return (
              <g key={i}>
                <rect x={ix} y={iy} width="10" height="10" rx="2.6" fill={app.cor} opacity="0.92" />
                <path
                  d={app.d}
                  transform={`translate(${ix}, ${iy}) scale(1)`}
                  fill="none"
                  stroke="#0b1b33"
                  strokeOpacity="0.72"
                  strokeWidth="0.9"
                  strokeLinejoin="round"
                  strokeLinecap="round"
                />
              </g>
            );
          })}

          {/* Barra de aplicativos do rodape, como num celular de verdade. */}
          <rect x={a.x - 14} y={a.y + 12} width="28" height="7" rx="3.5" fill="#0b1b33" opacity="0.14" />
          {[0, 1, 2].map((i) => (
            <circle key={`d-${i}`} cx={a.x - 8 + i * 8} cy={a.y + 15.5} r="1.9" fill="#0b1b33" opacity="0.4" />
          ))}
        </g>
      ))}

      {/* HUB. Escudo no meio: o que o centro faz e proteger e impor politica. */}
      <g>
        <circle cx={HUB.x} cy={HUB.y} r="46" fill="#0b1b33" stroke="#8fd4ff" strokeOpacity="0.5" strokeWidth="1.5" />
        <circle cx={HUB.x} cy={HUB.y} r="36" fill="url(#cd-hub)" />
        <path
          d={`M ${HUB.x} ${HUB.y - 20}
              L ${HUB.x + 15} ${HUB.y - 13}
              L ${HUB.x + 15} ${HUB.y + 4}
              Q ${HUB.x + 15} ${HUB.y + 17} ${HUB.x} ${HUB.y + 22}
              Q ${HUB.x - 15} ${HUB.y + 17} ${HUB.x - 15} ${HUB.y + 4}
              L ${HUB.x - 15} ${HUB.y - 13} Z`}
          fill="#0b1b33"
          fillOpacity="0.82"
        />
        <path
          d={`M ${HUB.x - 7} ${HUB.y + 1} l 5 5 l 9 -10`}
          fill="none"
          stroke="#8fd4ff"
          strokeWidth="2.4"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
}
